// extracted by mini-css-extract-plugin
export default {"StopBtn":"StopBtn_StopBtn__l4a-m"};